import { render, staticRenderFns } from "./msgtypeVideo.vue?vue&type=template&id=e58634ae&scoped=true&"
import script from "./msgtypeVideo.vue?vue&type=script&lang=js&"
export * from "./msgtypeVideo.vue?vue&type=script&lang=js&"
import style0 from "./msgtypeVideo.vue?vue&type=style&index=0&id=e58634ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e58634ae",
  null
  
)

export default component.exports